'use client';
import React, { createContext, useContext } from 'react';
import { Slide, toast, ToastContainer } from 'react-toastify';

import { NotificationType } from '@/notifications/Notification';
import type { Notification } from '@/notifications/Notification';

import '../../node_modules/react-toastify/dist/ReactToastify.css';
import '@/notifications/notifications.css';

export type NotificationsContextProps = {
  showNotification: (notification: Notification) => void;
};

const NotificationsContext = createContext<NotificationsContextProps>({
  showNotification: () => {},
});

export const useNotifications = () => {
  return useContext(NotificationsContext);
};

export const NotificationsProvider = ({ children }) => {
  const showNotification = (notification: Notification) => {
    switch (notification.type) {
      case NotificationType.ERROR:
        toast(notification.message, {
          type: 'error',
          autoClose: false,
        });
        break;
      case NotificationType.WARNING:
        toast(notification.message, {
          type: 'warning',
          autoClose: 5000,
        });
        break;
      case NotificationType.SUCCESS:
        toast(notification.message, {
          type: 'success',
          autoClose: 5000,
        });
        break;
    }
  };

  return (
    <NotificationsContext.Provider value={{ showNotification }}>
      {children}
      <ToastContainer
        closeOnClick
        hideProgressBar
        pauseOnFocusLoss
        pauseOnHover
        draggable={false}
        newestOnTop={false}
        position="bottom-right"
        rtl={false}
        theme="light"
        transition={Slide}
      />
    </NotificationsContext.Provider>
  );
};
